import { useLayoutEffect, useRef, useState } from 'react';

export const useIsOverflow = (callback, padding = 0) => {
  const [isOverflow, setIsOverflow] = useState(null);
  const ref = useRef(null);

  useLayoutEffect(() => {
    const { current } = ref;

    const checkOverflow = () => {
      const hasOverflow = current.scrollHeight > current.clientHeight + padding;
      setIsOverflow(hasOverflow);
      if (callback) callback(hasOverflow);
    };

    if (current) {
      checkOverflow();
    }
  }, [callback, padding]);

  return { isOverflow, ref };
};
